import { detect } from 'detect-browser';

export default function() {
  return detect();
}



// WEBPACK FOOTER //
// ./client/helper/environmentInfo.js